import { createFileRoute } from '@tanstack/react-router'
import { useUserSettingsStore } from '@zendia/frontend-shared'
import { ProfileSettingsPage } from '../../../components/Settings/ProfileSettingsPage'
import { useAutoSaveSettings } from '../../../components/Settings/useAutoSaveSettings'
import LifeDomainSatisfactionForm from '../../../screens/onboarding/forms/LifeDomainSatisfactionForm'
import { lifeDomainsWithSatisfaction } from '../../../utilities/lifeDomainSettings'

export const Route = createFileRoute('/_authenticated/settings/life-satisfaction')({
  component: LifeSatisfactionSettings,
})

function LifeSatisfactionSettings() {
  const { settings: userSettings } = useUserSettingsStore()
  const { save, retry, status } = useAutoSaveSettings()

  // No allocation is passed, so the form shows - and this re-sends - the saved weights.
  const onSubmit = (ratings: Record<string, number>) =>
    save({ lifeDomains: lifeDomainsWithSatisfaction(ratings, userSettings?.lifeDomains) })

  return (
    <ProfileSettingsPage
      title="Life satisfaction"
      description="How each area of your life actually feels today."
      saveStatus={status}
      onRetry={retry}
    >
      <LifeDomainSatisfactionForm onSubmit={onSubmit} autoSave />
    </ProfileSettingsPage>
  )
}
